
ko.bindingHandlers.colorPicker = {
    init: function (element, valueAccessor, allBindings, viewModel, context) {
        const saveMode = allBindings.get('colorMode') || 'RGBA';
        const assignedInput = '#' + allBindings.get('assignedInput');

        const pickr = Pickr.create({
            el: element,
            theme: 'nano', // or 'monolith', or 'nano'
            //useAsButton: true,
            //appendToBody: true,

            default: ko.unwrap(valueAccessor()) || null,

            swatches: [
                'rgba(161, 0, 0, 1)',
                'rgba(244, 67, 54, 1)',
                'rgba(233, 30, 99, 1)',
                'rgba(156, 39, 176, 1)',
                'rgba(103, 58, 183, 1)',
                'rgba(63, 81, 181, 1)',
                'rgba(33, 150, 243, 1)',
                'rgba(3, 169, 244, 1)',
                'rgba(0, 188, 212, 1)',
                'rgba(0, 150, 136, 1)',
                'rgba(76, 175, 80, 1)',
                'rgba(139, 195, 74, 1)',
                'rgba(205, 220, 57, 1)',
                'rgba(255, 235, 59, 1)',
                'rgba(255, 193, 7, 1)',
                'rgba(249, 149, 0, 1)'
                //'rgba(244, 67, 54, 1)',
                //'rgba(233, 30, 99, 0.95)',
                //'rgba(156, 39, 176, 0.9)',
                //'rgba(103, 58, 183, 0.85)',
                //'rgba(63, 81, 181, 0.8)',
                //'rgba(33, 150, 243, 0.75)',
                //'rgba(3, 169, 244, 0.7)',
                //'rgba(0, 188, 212, 0.7)',
                //'rgba(0, 150, 136, 0.75)',
                //'rgba(76, 175, 80, 0.8)',
                //'rgba(139, 195, 74, 0.85)',
                //'rgba(205, 220, 57, 0.9)',
                //'rgba(255, 235, 59, 0.95)',
                //'rgba(255, 193, 7, 1)'
            ],

            components: {

                // Main components
                preview: true,
                opacity: true,
                hue: true,

                // Input / output Options
                interaction: {
                    hex: true,
                    //rgba: true,
                    //hsla: true,
                    //hsva: true,
                    //cmyk: true,
                    input: true,
                    clear: true,
                    save: true
                }
            },
            strings: {
                save: 'Pick this color',  // Default for save button
                clear: 'Clear all', // Default for clear button
                cancel: 'Cancel' // Default for cancel button
            },
            defaultRepresentation: saveMode
        });

        const clearHandler = (e) => {
            valueAccessor()(null);
        };

        const saveHandler = (e) => {
            if (e) {
                if (saveMode == 'RGBA') {
                    valueAccessor()(e.toRGBA().toString(0));
                } else if (saveMode == 'HEX') {
                    valueAccessor()(e.toHEXA().toString(0));
                } else {
                    throw new Error('colorMode must be set');
                    //valueAccessor()(e.toHEXA().toString(0));
                }
            }

            pickr.hide();
        };

        pickr.on('clear', clearHandler);
        pickr.on('save', saveHandler);

        let subscription = valueAccessor().subscribe((val) => {
            pickr.setColor(val || '', true);
        });

        const assignedInputHandler = function (event) {
            if (event.type == 'keypress') {
                var keyCode = (event.which ? event.which : event.keyCode);
                if (keyCode === 13) {
                    pickr.setColor(event.target.value || '');
                    return false;
                }
            } else if (event.type == 'focusout') {
                pickr.setColor(event.target.value || '');
            }
            return true;
        };

        $(document).on('keypress', assignedInput, assignedInputHandler);
        $(document).on('blur', assignedInput, assignedInputHandler);

        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            pickr.off('clear', clearHandler);
            pickr.off('save', saveHandler);

            $(document).off('keypress', assignedInput, assignedInputHandler);
            $(document).off('blur', assignedInput, assignedInputHandler);

            subscription.dispose();

            pickr.destroy();
        });
    },
    update: function (element, valueAccessor, allBindings, viewModel, context) {

    }
};